import styled from 'styled-components'

export const Content = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const Describer = styled.div`
  width: 100%;
  height: 100px;
  display: contents;
`

export const Provider = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  flex-direction: column;
  display: contents;
`

export const Search = styled.div`
  height: 30px;
  width: 100%;
  background-color: green;
`
export const ListProvider = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: 100%;
  overflow: auto;
`

export const InputSearchContent = styled.div`
  height: fit-content;
  width: 100%;
`
export const ProviderList = styled.div`
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
`

export const ProviderCard = styled.div`
  width: 100px;
  height: 100px;
  background-color: #aaa;
  border-radius: 5px;
  padding: 5px;
  margin: 5px;
`

export const ProviderConfirmation = styled.div`
  margin: 10px;
`

export const ListItemProvider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 400px;
  max-width: fit-content;
  margin: 5px auto;
`
export const ListItemProviderContent = styled.div`
  width: 100%;
  background-color: #eeeeee;
  transition: border 0.2s ease-in-out;
  border-bottom: 2px #bdbdbd solid;

  ${ListItemProvider}:hover & {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    /* border-bottom: 2px #616161 solid; */
    background-color: #bdbdbd;
  }
`
